import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Accelerator() {
  const rows = [{
    sit: 'Tipo de cliente',
    sin: 'Clientes con poco presupuesto que buscan ofertas',
    con: 'Empresas y Perfiles VIP'
  }, {
    sit: 'Margen de ganancia',
    sin: 'Ajustado por competencia',
    con: 'Doble o triple por caja'
  }, {
    sit: 'Estabilidad',
    sin: 'Dependés de cumpleaños',
    con: 'Contratos mensuales fijos'
  }, {
    sit: 'Packaging',
    sin: 'Estándar de cartón',
    con: 'Sello de lacre, seda y autor'
  }, {
    sit: 'Posicionamiento',
    sin: '"La chica/o que hace cajas"',
    con: '"Atelier de Regalos Premium"'
  }];
  return <section className="py-16 px-4 bg-dark-card/30" data-id="element-28">
      <div className="max-w-4xl mx-auto" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-31">
            💎 ¿QUÉ AGREGA EL MÉTODO BOUTIQUE?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-32">
            El Método Boutique es el motor de escala del Ultrapack. No es solo
            "vender más", es vender mejor a quienes tienen el presupuesto.
          </p>
        </div>

        <div className="space-y-6" data-id="element-33">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl overflow-hidden" data-id="element-34">
              <div className="p-6 border-b border-dark-border" data-id="element-35">
                <h3 className="text-lg font-bold text-white" data-id="element-36">{row.sit}</h3>
              </div>
              <div className="grid md:grid-cols-2" data-id="element-37">
                <div className="p-6 bg-red-500/5 border-r border-dark-border" data-id="element-38">
                  <div className="flex items-center space-x-2 mb-3" data-id="element-39">
                    <X className="w-5 h-5 text-red-400" data-id="element-40" />
                    <span className="font-bold text-red-400" data-id="element-41">
                      Sin Método Boutique
                    </span>
                  </div>
                  <p className="text-gray-400" data-id="element-42">{row.sin}</p>
                </div>
                <div className="p-6 bg-brand/5" data-id="element-43">
                  <div className="flex items-center space-x-2 mb-3" data-id="element-44">
                    <Check className="w-5 h-5 text-brand" data-id="element-45" />
                    <span className="font-bold text-brand" data-id="element-46">
                      Con Método Boutique
                    </span>
                  </div>
                  <p className="text-white font-medium" data-id="element-47">{row.con}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}